export const getMaintenanceMessages = (intl, maintenanceStatus) => {
    const maintenanceStartDateTime = maintenanceStatus?.startDateTime
        ? `${intl.formatDate(new Date(maintenanceStatus.startDateTime))} ${intl.formatTime(new Date(maintenanceStatus.startDateTime))}`
        : '';
    const maintenanceEndDateTime = maintenanceStatus?.endDateTime
        ? `${intl.formatDate(new Date(maintenanceStatus.endDateTime))} ${intl.formatTime(new Date(maintenanceStatus.endDateTime))}`
        : '';
    const maintenanceMessage = (maintenanceStatus?.maintenanceMessage?.localizedValue || '')
        .replaceAll('{startDateTime}', maintenanceStartDateTime)
        .replaceAll('{endDateTime}', maintenanceEndDateTime);
    const warningBannerMessage = (maintenanceStatus?.warningBannerMessage?.localizedValue || '')
        .replaceAll('{startDateTime}', maintenanceStartDateTime)
        .replaceAll('{endDateTime}', maintenanceEndDateTime);

    return {
        maintenanceStartDateTime,
        maintenanceEndDateTime,
        maintenanceMessage,
        warningBannerMessage,
    };
};